module.exports = __webpack_public_path__ + "static/media/menu.61d784bd.svg";